import React from 'react';
import { useAuth } from '../hooks/useAuth';
import AppLayout from './layout/AppLayout';

function Profile() {
  const { user } = useAuth();

  const userEmail = user?.email || user?.email_address || 'N/A';

  return (
    <AppLayout>
      <div className="w-full">
        <div className="mb-6">
          <h1 className="text-2xl font-semibold text-gray-900">Profile</h1>
          <p className="mt-1 text-sm text-gray-500">
            View and manage your account information
          </p>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 px-6 sm:px-8 py-8">
            <div className="flex flex-col sm:flex-row items-center sm:items-start space-y-4 sm:space-y-0 sm:space-x-6">
              <div className="relative">
                <div className="h-24 w-24 sm:h-32 sm:w-32 rounded-full flex items-center justify-center text-white font-semibold text-3xl sm:text-4xl shadow-xl border-4 border-white">
                <svg id="Layer_1" className='w-20 h-20' viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1"><ellipse cx="255.999" cy="116.444" fill="#00ffb0" rx="94.445" ry="94.44" transform="matrix(.003 -1 1 .003 138.899 372.144)"/><path d="m189.327 270.173h133.344c75.716 0 137.316 61.6 137.316 137.33v63.379a17.135 17.135 0 0 1 -17.107 17.118h-59.25v-93.518a12 12 0 1 0 -24 0v93.518h-207.262v-93.518a12 12 0 1 0 -24 0v93.518h-59.25a17.142 17.142 0 0 1 -17.111-17.121v-63.379c0-75.73 61.6-137.33 137.32-137.33zm-161.32 137.327v63.379a41.165 41.165 0 0 0 41.111 41.121h373.762a41.165 41.165 0 0 0 41.111-41.12v-63.38a161.745 161.745 0 0 0 -161.32-161.329h-133.344a161.762 161.762 0 0 0 -161.32 161.329zm135.552-291.056a92.44 92.44 0 1 1 92.441 92.445 92.55 92.55 0 0 1 -92.44-92.445zm208.88 0a116.44 116.44 0 1 0 -116.439 116.444 116.574 116.574 0 0 0 116.439-116.444z" fill="#143565" fillRule="evenodd"/></svg>
                </div>
              </div>

              <div className="flex-1 text-center sm:text-left">
                <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3">Email Address</h2>
                <div>
                  <p className="text-gray-600 text-lg">{userEmail}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AppLayout>
  );
}

export default Profile;

